export default {
    // Endpoints
    loginEndpoint: '/auth/login',
    registerEndpoint: '/auth/register',
    refreshEndpoint: '/refresh-data',
    logoutEndpoint: '/logout',
    resetPasswordEndpoint: '/reset-password',
    forgotPasswordEndpoint: '/forgot-password',
    resetPasswordEndpoint: '/reset-password',
    enableAccountEndpoint: '/enable-account',
    userListEndpoint: '/user',
    settingsEndpoint: '/settings',

    // This will be prefixed in authorization header with token
    // e.g. Authorization: Bearer <token>
    tokenType: 'Bearer',

    // Value of this property will be used as key to store JWT token in storage
    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken',
}
